/**
 * 弹窗队列管理器
 * 按优先级排序 + 阻塞条件控制展示时机
 */
export class PopupQueue {
  constructor() {
    this.queue = [] // 待展示队列（按优先级降序）
    this.activePopup = null // 当前展示中的弹窗 ID
    this.blockers = new Set() // 当前活跃的阻塞条件
  }

  /**
   * 注册弹窗请求到队列
   * @param {Object} options
   * @param {string} options.id - 弹窗唯一标识
   * @param {number} options.priority - 优先级（数字越大越先展示）
   * @param {string[]} options.blockers - 需等待解除的阻塞条件
   * @param {Function} options.show - 展示弹窗的回调
   */
  enqueue({ id, priority, blockers = [], show }) {
    if (this.queue.find((p) => p.id === id)) return
    this.queue.push({ id, priority, blockers, show })
    this.queue.sort((a, b) => b.priority - a.priority)
    this._tryNext()
  }

  /**
   * 声明阻塞条件生效
   * @param {string} name - 阻塞条件名称
   */
  addBlocker(name) {
    this.blockers.add(name)
  }

  /**
   * 解除阻塞条件，尝试展示下一个弹窗
   * @param {string} name - 阻塞条件名称
   */
  removeBlocker(name) {
    this.blockers.delete(name)
    setTimeout(() => this._tryNext(), 300)
  }

  /**
   * 当前弹窗关闭时调用，尝试展示下一个
   * @param {string} popupId - 弹窗 ID
   */
  resolve(popupId) {
    if (this.activePopup === popupId) {
      this.activePopup = null
      this._tryNext()
    }
  }

  /**
   * 移除队列中未展示的弹窗
   * @param {string} popupId - 弹窗 ID
   */
  remove(popupId) {
    this.queue = this.queue.filter((p) => p.id !== popupId)
  }

  /**
   * 内部：检查队列中是否有可展示的弹窗
   */
  _tryNext() {
    if (this.activePopup) return
    const next = this.queue.find((p) => p.blockers.every((b) => !this.blockers.has(b)))
    if (!next) return
    this.queue = this.queue.filter((p) => p.id !== next.id)
    this.activePopup = next.id
    next.show()
  }
}
